import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/acp-mobile-sdkdocs/acp-mobile-sdkdocs/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
import Alerts from '../resources/alerts.md';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "mobile-core"
    }}>{`Mobile Core`}</h1>
    <Alerts query="platform=outdated-version&componentClass=InlineNestedAlert" mdxType="Alerts" />
    <InlineAlert variant="warning" slots="text" mdxType="InlineAlert" />
    <p>{`As of `}<strong parentName="p">{`April 1, 2020`}</strong>{`, Apple will no longer support the UIWebView API. To avoid any issues, ensure that you are using iOS SDK version 2.3.4 or later. For more information about the UIWebView API, see `}<a parentName="p" {...{
        "href": "https://developer.apple.com/documentation/uikit/uiwebview"
      }}>{`UIWebView `}</a>{`.`}</p>
    <p>{`Mobile Core is mandatory for all Adobe Experience Platform app implementations. Mobile Core contains a common set of functionality and frameworks, including Experience Cloud Identity services, data event hub, Rules Engine, reusable networking, and disk access routines. The following sections provide additional information about what is provided in the Mobile Core extension.`}</p>
    <h2 {...{
      "id": "mobile-core-generic-apis"
    }}>{`Mobile Core generic APIs`}</h2>
    <p>{`The SDK provides core, extension-independent APIs to facilitate the event tracking of user screens, actions, and PII data. Events generated by these APIs are published to the SDK event hub and are available for use by extensions. For instance, when the Analytics extension is installed, all user actions and app screens event data is sent to the appropriate Analytics reporting endpoints.`}</p>
    <p>{`For more information, please read the `}<a parentName="p" {...{
        "href": "api-reference.md"
      }}>{`Mobile Core API reference`}</a>{`.`}</p>
    <h2 {...{
      "id": "configuration"
    }}>{`Configuration`}</h2>
    <p>{`The Configuration extension provides different APIs to set up the SDK's configuration settings. For more information, please read the documentation on the `}<a parentName="p" {...{
        "href": "configuration/index.md"
      }}>{`Configuration extension`}</a>{`.`}</p>
    <h2 {...{
      "id": "identity"
    }}>{`Identity`}</h2>
    <p>{`The Identity framework lets your app use Experience Cloud ID (ECID). Using ECIDs improves synchronization with Adobe and other customer identifiers. For more information, please read the documentation on the `}<a parentName="p" {...{
        "href": "identity/index.md"
      }}>{`Identity extension`}</a>{`.`}</p>
    <h2 {...{
      "id": "lifecycle"
    }}>{`Lifecycle`}</h2>
    <p>{`The Lifecycle extension lets you access information about the app's sessions, including device information, app installation, app upgrades, session start and pause times, number of application launches, and additional context data. For more information on how to use the Lifecycle API, please read the documentation on the `}<a parentName="p" {...{
        "href": "lifecycle/index.md"
      }}>{`Lifecycle extension`}</a>{`.`}</p>
    <h2 {...{
      "id": "rules-engine"
    }}>{`Rules Engine`}</h2>
    <p>{`Rules Engine looks for the interactions between users and their associated data and lets you trigger specified actions based on rules that you define. For more information, please read the documentation on the `}<a parentName="p" {...{
        "href": "rules-engine/index.md"
      }}>{`Rules Engine`}</a>{`.`}</p>
    <h2 {...{
      "id": "signal"
    }}>{`Signal`}</h2>
    <p>{`The Signal extension allows you to send data third-party endpoints via GET and POST requests. Signals are configured by using rules in the Data Collection UI. For more information, please read the documentation on the `}<a parentName="p" {...{
        "href": "signals/index.md"
      }}>{`Signal extension`}</a>{`.`}</p>
    <h2 {...{
      "id": "platform-services"
    }}>{`Platform Services`}</h2>
    <p>{`The interaction with native platforms is mainly built into the Platform Services layer, which is used across all the extensions. It also makes it easy for the apps to customize the behavior if needed. For more information, see `}<a parentName="p" {...{
        "href": "platform-services/index.md"
      }}>{`Platform Services`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      